module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"leave_us_message_question":"How can we help you?","leave_us_message_desc":"If you have any questions, please contact us at support@yezza.io. We\u0027d be happy to help."},"id":{"leave_us_message_question":"Bagaimana kami bisa bantu anda?","leave_us_message_desc":"Jika kamu memiliki pertanyaan, silakan hubungi kami di support@yezza.io. Kami siap membantu."}}')
  delete Component.options._Ctor
}
